<div class="tab-pane" role="tabpanel" id="disposicion">
    <fieldset id="agregar_disposicion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Disposiciones Especiales a que se acogera el proyecto</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion1" name="disposicion1" formControlName="disposicion1" (change)="add_disposiciones_esp()" value="SI">D.F.L N2 de 1959</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion2" name="disposicion2" formControlName="disposicion2" (change)="add_disposiciones_esp()" value="SI">Ley 19.537 Copropiedad Inmobiliaria</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion3" name="disposicion3" formControlName="disposicion3" (change)="add_disposiciones_esp()" value="SI">Proyeccion Sombras Art 2.6.11 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion4" name="disposicion4" formControlName="disposicion4" (change)="add_disposiciones_esp()" value="SI">Segunda Vivienda Art 6.2.4 OGUC</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion5" name="disposicion5" formControlName="disposicion5" (change)="add_disposiciones_esp()" value="SI">Conjunto Armonico Art 2.6.4 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion6" name="disposicion6" formControlName="disposicion6" (change)="add_disposiciones_esp()" value="SI">Beneficio Fusion Art 63 LGUC</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="disposicion7" name="disposicion7" formControlName="disposicion7" (change)="add_disposiciones_esp()" value="SI">Conj. Viv Econ Art 6.1.8 OGUC</mat-checkbox>
                                </div>
                                <div class="col-md-6" *ngIf="!encontrado">
                                    <mat-checkbox id="disposicion8" name="disposicion8" formControlName="disposicion8" (change)="add_disposiciones_esp()" value="SI">Otro (Especificar)</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>